var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallbackLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_35161",
    "data-name": "Group 35161",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96.002,
    viewBox: "0 0 96 96.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9538",
    "data-name": "Rectangle 9538",
    width: 44.615,
    height: 47.501,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26955",
    "data-name": "Group 26955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32574",
    "data-name": "Path 32574",
    d: "M40,0A40,40,0,1,1,0,40,40,40,0,0,1,40,0Z",
    transform: "translate(8 8)",
    fill: "#4b74f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32574_-_Outline",
    "data-name": "Path 32574 - Outline",
    d: "M40,0A40,40,0,1,0,80,40,40,40,0,0,0,40,0m0-8A48,48,0,1,1-8,40,48.055,48.055,0,0,1,40-8Z",
    transform: "translate(8 8)",
    fill: "rgba(75,116,244,0.3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44288",
    "data-name": "Group 44288",
    transform: "translate(25.692 24.25)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43546",
    "data-name": "Path 43546",
    d: "M43.135.69,41.716.666a1.51,1.51,0,0,0-1.531,1.48l-.074,4.375A23.745,23.745,0,1,0,26.745,47.309a23.945,23.945,0,0,0,5-1.2A23.631,23.631,0,0,0,42.885,37.82,2.285,2.285,0,1,0,39.2,35.115,19.177,19.177,0,1,1,36.59,9.486l-4.008-.067a1.51,1.51,0,0,0-1.531,1.48l-.025,1.5a1.51,1.51,0,0,0,1.48,1.531l8.985.151,1.419.024a1.51,1.51,0,0,0,1.531-1.48l.025-1.5h0l.15-8.9A1.51,1.51,0,0,0,43.135.69",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallbackLogo);
export default __webpack_public_path__ + "static/media/callbackLogo.227f0b1d13d9beacbaa310798461b686.svg";
export { ForwardRef as ReactComponent };